import React from 'react';
import { Box, Flex, Th } from '@chakra-ui/react';
import { MdArrowDownward, MdArrowUpward, MdUnfoldMore } from 'react-icons/md';

/**
 * Table header cell that toggles asc → desc → none.
 * Pair with the useTableSort hook.
 */
export function SortableTh({ columnKey, sort, onSort, children, ...props }) {
  const isActive = sort?.key === columnKey;
  const dir = isActive ? sort.dir : null;
  const ariaSort = dir === 'asc' ? 'ascending' : dir === 'desc' ? 'descending' : 'none';

  const Icon =
    dir === 'asc' ? MdArrowUpward : dir === 'desc' ? MdArrowDownward : MdUnfoldMore;

  return (
    <Th
      {...props}
      aria-sort={ariaSort}
      cursor="pointer"
      userSelect="none"
      color={isActive ? 'text.primary' : undefined}
      _hover={{ color: 'text.primary', '& .sort-icon': { opacity: 1 } }}
      onClick={() => onSort?.(columnKey)}
    >
      <Flex align="center" gap={1} justify={props.isNumeric ? 'flex-end' : 'flex-start'}>
        <Box>{children}</Box>
        <Box
          as={Icon}
          className="sort-icon"
          size="13px"
          flexShrink={0}
          opacity={isActive ? 1 : 0.35}
        />
      </Flex>
    </Th>
  );
}
